import { render, staticRenderFns } from "./MeasuringList.vue?vue&type=template&id=b3512e72&scoped=true"
import script from "./MeasuringList.vue?vue&type=script&lang=ts"
export * from "./MeasuringList.vue?vue&type=script&lang=ts"
import style0 from "./MeasuringList.vue?vue&type=style&index=0&id=b3512e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3512e72",
  null
  
)

export default component.exports